/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface CreateInitialAdminUserDto
 */
export interface CreateInitialAdminUserDto {
    /**
     * 
     * @type {string}
     * @memberof CreateInitialAdminUserDto
     */
    surname: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInitialAdminUserDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInitialAdminUserDto
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInitialAdminUserDto
     */
    $type?: CreateInitialAdminUserDtoTypeEnum;
}


/**
 * @export
 */
export const CreateInitialAdminUserDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedInstallDtoCreateInitialAdminUserDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Install.Dto.CreateInitialAdminUserDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateInitialAdminUserDtoTypeEnum = typeof CreateInitialAdminUserDtoTypeEnum[keyof typeof CreateInitialAdminUserDtoTypeEnum];



/**
 * Check if a given object implements the CreateInitialAdminUserDto interface.
 */
export function instanceOfCreateInitialAdminUserDto(value?: unknown): value is CreateInitialAdminUserDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateInitialAdminUserDtoTypeEnum)[0];
}

export function CreateInitialAdminUserDtoFromJSON(json: any): CreateInitialAdminUserDto {
    return CreateInitialAdminUserDtoFromJSONTyped(json, false);
}

export function CreateInitialAdminUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateInitialAdminUserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'surname': json['surname'],
        'email': json['email'],
        'password': json['password'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateInitialAdminUserDtoToJSON(value?: CreateInitialAdminUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'surname': value['surname'],
        'email': value['email'],
        'password': value['password'],
        '$type': value['$type'],
    });
}

